var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"userSettings"},[_c('div',{staticClass:"loginOutBox",on:{"click":_vm.loginOut}},[_c('div',{staticClass:"loginOut"},[_c('van-image',{attrs:{"width":"20","height":"20","src":_vm.logout}}),_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t.auth.logout))])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }